<app-header></app-header>
<!-- with anpi section -->
<section *ngIf="isAnpiSection" id="anpi-section">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 offset-md-2 col-sm-12 offset-sm-0">
        <img src="assets/images/sync-image-Charac.png" class="landimage">
      </div>
    </div>
    <div class="text-container card-large">
      <!-- <h5 class="form-title text-center">{{'Link your ANPI Account with CCPS portal' | translate}}</h5>
      <p class="para-light text-center">{{'Click' | translate }}<a href="https://www.gni-anpigabon.com" target="_blank"><img src="/assets/images/gni-trans.png"></a><span>{{'link anpi paragraph' | translate}}</span></p> -->
      <p class="para-light text-center">{{'Kindly provide your Tax Identification Number (NIF) to allow the system to automatically fetch your company’s information from official public databases (DGI, ANPI-Gabon, CNSS, CNAMGS).' | translate}}</p>
      <form id="anpi-form" [formGroup]="anpiAccountLinkForm" (ngSubmit)="onSubmitAnpiCode()">
        <div class="input-container input-box-white mb-0">
          <label class="labeltxt text-center">{{'Tax Identification Number (NIF)' | translate}}</label>
          <input class="text-center" type="text" formControlName="anpi_code" name="anpicode">
          <div *ngIf="isSubmitted && f.anpi_code.errors" class="invalid-feedback text-center">
            <div *ngIf="f.anpi_code.errors?.required">{{'Tax Identification Number (NIF)'|translate}} {{'is required'|translate}}</div>
            <div *ngIf="f.anpi_code.errors?.pattern">{{'Tax Identification Number (NIF)'|translate}} {{'should be valid' | translate}}</div>
          </div>
        </div>

        <div class="radio-box-section">
          <div class="radio-box-container">
            <p class="radio-box-title">{{'Have you registered in CNSS and CNAMGS ?' | translate}}</p>
            <div class="checkbox-group">
              <mat-checkbox formControlName="is_cnamgs" class="mat-checkbox-btn">
                <div class="label-img-div"><img src="assets/images/cnamgslogo.png" alt="" class="img-fluid"> </div> 
              </mat-checkbox>
              <mat-checkbox formControlName="is_cnss" class="mat-checkbox-btn">
                <div class="label-img-div"><img src="assets/images/CNSS-logo-col.png" alt="" class="img-fluid"> </div>  
              </mat-checkbox>
            </div>
          </div>
        </div>

        <button type="submit" id="submit_btn" class="btn btn-medium">{{'Get Started' | translate}}</button>
      </form>
    </div>
  </div>
</section>
<!-- without anpi section -->
<!--  <section id="noanpi-section" class="creation-form">
      <div class="container-fluid">
        <div class="text-container">
            <h5 class="form-title">{{'Enter Company Details' | translate}}</h5>
            <form id="noanpi-form" [formGroup]="languageForm">
                <div class="input-container form-input">
                    <div class="child-container">
                        <label class="labeltxt">{{'Company Name' | translate}}</label>
                        <input class="" type="text" name="companyName">
                    </div>
                   <div class="child-container">
                        <label class="labeltxt">{{'Company Type' | translate}}</label>
                         <select class="bootstrap-select">
                          <option value="1" selected>SAU</option>
                          <option value="2">SARL</option>
                          <option value="3">SARLU</option>
                          <option value="5">SAS</option>SA
                          <option value="6">SASU</option>SA
                          <option value="7">GIE</option>SA
                          <option value="8">SCI</option>SA
                          <option value="9">Scoops</option>SA
                          <option value="10">Coop-CA</option>SA
                          <option value="11">SNC</option>SA
                          <option value="12">SCS</option>SA 
                        </select>
                    </div>
                    <div class="child-container">
                        <label class="labeltxt">{{'Main Office Line' | translate}}</label>
                        <input class="" type="text" name="companyName">
                    </div>
                    <div class="child-container">
                        <label class="labeltxt">{{'Email Address' | translate}}</label>
                        <input class="" type="text" name="companyName">
                    </div> 
                     <div class="child-container">
                        <label class="labeltxt">{{'ANPI No' | translate}}:</label>
                        <input class="" type="text" name="companyName">
                    </div>
                     <div class="child-container">
                        <label class="labeltxt">{{'N NIF' | translate}}</label>
                        <input class="" type="text" name="companyName">
                    </div>
                     <div class="child-container">
                        <label class="labeltxt">{{'N RCCM' | translate}}</label>
                        <input class="" type="text" name="companyName">
                    </div>
                     <div class="child-container">
                        <label class="labeltxt">{{'N FOLIO' | translate}}</label>
                        <input class="" type="text" name="companyName">
                    </div>
                     <div class="child-container">
                        <label class="labeltxt">{{'N CNSS' | translate}}</label>
                        <input class="" type="text" name="companyName">
                     </div>
                    <div class="child-container">
                        <label class="labeltxt">{{'N CNAMGS' | translate}}</label>
                        <input class="" type="text" name="companyName">
                    </div>
                    <div class="child-container">
                        <label for="company-logo" class="labeltxt">{{'Upload Company Logo' | translate}}</label>
                        <label for="company-logo" class="file-upload-card single-card labeltxt"><div class="custom-container"><img src="assets/images/upload_icon.png">
                                    <p class="text-center">{{'Upload image or drop a file' | translate}}</p></div></label>
                        <input class="" id="company-logo" type="file" name="companyName" onchange="displayFileName('company-logo', 'companyLogoName')">
                        <a class="text-center viewFile" href="" id="companyLogoName"></a>
                    </div>
                </div>
                 <button type="button" id="submit_btn" class="btn btn-main2" (click)="showCompanyDetails()">{{'Done' | translate}}</button>
            </form>
        </div>
      </div>
</section> -->
<!-- company details section -->
<section [hidden]="isAnpiSection" id="company-details-section">
  <div class="container-fluid">
    <div class="initiale_sestion">
      <div class="head">
        <div class="title-container">
          <i (click)="goBack()" class="fa-solid fa-angle-left"></i>
        </div>
      </div>
    </div>
    <div *ngIf="rejectReason && rejectReason != null && rejectReason != ''" class="reason_for_reject container">
      <div class="rejectedNote">
        <div class="id-status">
          <img class="img-fluid" src="/assets/images/reject.png">
          <h5 class="m-0 align-self-center">{{'Rejected' | translate}}</h5>
        </div>
        <div class="d-flex">
          <h5 *ngIf="rejectReason?.rejected_status">{{'Status2'| translate}}&nbsp;:&nbsp;
          </h5>
          <h6> {{rejectReason?.action}}</h6>
        </div>
        <!-- <h5 *ngIf="rejectReason.rejected_by">{{'Rejected by'| translate}} : {{rejectReason.rejected_by}}</h5> -->
        <h5>{{'Rejected on'| translate}} : {{rejectReason?.rejected_on}}</h5>
        <h5>{{'Comments'| translate}} : {{rejectReason?.rejected_comment}}</h5>
      </div>
    </div>
    <div *ngIf="accountDetails.GNI !=0" class="addButton">
      <p class="mb-2 ">{{'You can modify the details in the form below and resubmit. If you need to edit the details that were migrated from the GNI, please first log in to the GNI portal, make the necessary changes, obtain approval, and then remigrate here by clicking the button..'| translate}}</p>
      <div class="text-container">
        <div class="custom-container modify-btn">
          <button class="btn-medium" (click)="refetchAnpiCode()"><i class="fa-solid fa-rotate mr-1"></i>{{'Refetch with ANPI Number'|translate}}</button>
        </div>
      </div>
    </div>
    <!--     <div *ngIf="rejectReason" class="reason_for_reject container">
      <div *ngIf="rejectReason" class="rejectedNote">
        <div class="d-flex">
          <h5 *ngIf="rejectReason.rejected_status">{{'Status2'| translate}}&nbsp;:&nbsp;
          </h5>
          <h6> {{rejectReason.action}}</h6>
        </div>
        <h5 *ngIf="rejectReason.rejected_on">{{'Rejected on'| translate}} : {{rejectReason.rejected_on}}</h5>
        <h5 *ngIf="rejectReason.rejected_comment">{{'Comments'| translate}} : {{rejectReason.rejected_comment}}</h5>

        <div class="addButton">
          <p class="mb-2">{{'You can modify the details in the form below and resubmit. If you need to edit the details that were migrated from the GNI, please first log in to the GNI portal, make the necessary changes, obtain approval, and then remigrate here by clicking the button..'| translate}}</p>
          <div class="custom-text-container">
            <div class="custom-container">
              <button class="btn-medium" (click)="refetchAnpiCode()"><i class="fa-solid fa-rotate mr-1"></i>{{'Refetch ' | translate}} with {{'ANPI Number'|translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <div class="text-container card-large">
      <h5 class="form-title text-center">{{'Description' | translate}}</h5>
      <p class="para-light text-center ">{{'informations para 1' | translate}} <br>
        {{'informations para 2' | translate}}<b>{{'click next' | translate}}</b></p>
      <div class="image-container">
        <div class="logo">
          <img src="{{companyDetails?.company_logo}}">
          <!-- <i class="fa-regular fa-building"></i> -->
        </div>
        <h3 class="text-capitalize" *ngIf="companyDetails">{{companyDetails.name}}</h3>
      </div>
      <form [formGroup]="companyDetailsForm" (ngSubmit)="onSubmitCompanyDetails()">
        <div class="parent-container">
          <div class="enroll_form">
            <div class="input_section">
              <div class="container mt-5">
                <h6 class="">{{'Business or Administration Details' | translate}}</h6>
              </div>
              <div class="line"></div>
              <div class="container">
                <div class="row">
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'ANPI Number'|translate}}</label>
                    <input type="text" formControlName="anpi_no" maxlength="40">
                    <div *ngIf="isSubmitted && g.anpi_no.errors" class="invalid-feedback">
                      <div *ngIf="g.anpi_no.errors?.required">{{'ANPI Number'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.anpi_no.errors?.pattern">{{'ANPI Number'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Nº NIF (DGI)'|translate}}</label>
                    <input type="text" formControlName="nif" maxlength="40">
                    <div *ngIf="isSubmitted && g.nif.errors" class="invalid-feedback">
                      <div *ngIf="g.nif.errors?.required">{{'Nº NIF (DGI)'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.nif.errors?.pattern">{{'Nº NIF (DGI)'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Nº RCCM'|translate}}</label>
                    <input type="text" formControlName="rccm" maxlength="40">
                    <div *ngIf="isSubmitted && g.rccm.errors" class="invalid-feedback">
                      <div *ngIf="g.rccm.errors?.required">{{'Nº RCCM'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.rccm.errors?.pattern">{{'Nº RCCM'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <!-- new fields -->
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Company Type'|translate}}</label>
                    <input class="text-capitalize" type="text" value="" formControlName="legal_status" maxlength="40">
                    <div *ngIf="isSubmitted && g.legal_status.errors" class="invalid-feedback">
                      <div *ngIf="g.legal_status.errors?.required">{{'Company Type'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.legal_status.errors?.pattern">{{'Company Type'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <!-- <div class="col-md-6 mt-3">
                    <label for="">{{'Type d’entreprise'|translate}}</label>
                    <input class="text-capitalize" type="text" value="Entreprise Individuelle" formControlName="company_type">
                    <div *ngIf="isSubmitted && g.company_type.errors" class="invalid-feedback">
                      <div *ngIf="g.company_type.errors?.required">{{'Type d’entreprise'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.company_type.errors?.pattern">{{'Type d’entreprise'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div> -->
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Dénomination sociale'|translate}}</label>
                    <input type="text" value="" formControlName="name" maxlength="40">
                    <div *ngIf="isSubmitted && g.name.errors" class="invalid-feedback">
                      <div *ngIf="g.name.errors?.required">{{'Dénomination sociale'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.name.errors?.pattern">{{'Dénomination sociale'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Nom Commercial'|translate}}</label>
                    <input class="text-capitalize" type="text" formControlName="trade_name" maxlength="40">
                    <div *ngIf="isSubmitted && g.trade_name.errors" class="invalid-feedback">
                      <div *ngIf="g.trade_name.errors?.required">{{'Nom Commercial'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.trade_name.errors?.pattern">{{'Nom Commercial'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Nº CNSS'|translate}}</label>
                    <input type="text" formControlName="cnss" (input)="formatCNSS($event)" maxlength="13">
                    <div class="text-sm textUnderMobile">Note : {{'format is' | translate}} ###-#######-X</div>
                    <div *ngIf="isSubmitted && g.cnss.errors" class="invalid-feedback">
                      <div *ngIf="g.cnss.errors?.required">{{'Nº CNSS'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.cnss.errors?.pattern">{{'Nº CNSS'|translate}} {{'should be valid'|translate}}
                    </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Nº CNAMGS'|translate}}</label>
                    <input type="text" formControlName="cnamgs" maxlength="15" (input)="formatCNAMGS($event, '1')">
                    <div class="text-sm textUnderMobile">Note : {{'format is' | translate}} ###-###-###-###</div>
                    <div *ngIf="isSubmitted && g.cnamgs.errors" class="invalid-feedback" maxlength="15">
                      <div *ngIf="g.cnamgs.errors?.required">{{'Nº CNAMGS'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.cnamgs.errors?.pattern">{{'Nº CNAMGS'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <!-- Below section is under Business or Administration Details -->
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Mobile'|translate}}</label>
                    <input type="text" value="" formControlName="mobile">
                    <!-- <div class="text-sm">{{'Mobile should start with valida numbers like 77, 74, 61, 66, 62, 60, 65, 76'|translate}}</div> -->
                    <div *ngIf="isSubmitted && g.mobile.errors" class="invalid-feedback">
                      <!-- <div *ngIf="g.mobile.errors?.required">{{'Mobile'|translate}} {{'is required'|translate}}</div> -->
                      <div *ngIf="g.mobile.errors?.pattern">{{'Mobile'|translate}} {{'should be valid'|translate}}</div>
                      <!--     <div *ngIf="g.telephone.hasError('minlength')">{{ 'Mobile' | translate }} {{ 'must Contain 8 Numbers' | translate }}</div>
                      <div *ngIf="g.telephone.hasError('maxlength')">{{ 'Mobile' | translate }} {{ 'must Contain only 8 Numbers' | translate }}</div> -->
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Acronym'|translate}}</label>
                    <input type="text" formControlName="acrononym" maxlength="40">
                    <div *ngIf="isSubmitted && g.acrononym.errors" class="invalid-feedback">
                      <div *ngIf="g.acrononym.errors?.required">{{'Acronym'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.acrononym.errors?.pattern">{{'Acronym'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Nº VOL'|translate}}</label>
                    <input type="text" formControlName="vol" maxlength="40">
                    <div *ngIf="isSubmitted && g.vol.errors" class="invalid-feedback">
                      <div *ngIf="g.vol.errors?.required">{{'Nº VOL'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.vol.errors?.pattern">{{'Nº VOL'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Nº FOLIO'|translate}}</label>
                    <input type="text" formControlName="folio" maxlength="40">
                    <div *ngIf="isSubmitted && g.folio.errors" class="invalid-feedback">
                      <div *ngIf=" g.folio.errors?.required">{{'Nº FOLIO'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.folio.errors?.pattern">{{'Nº FOLIO'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <!-- Business or Administration Details  ends -->
                </div>
              </div>
              <div class="container mt-5">
                <h6 class="">{{'Business Location' | translate}}</h6>
              </div>
              <div class="line"></div>
              <div class="container">
                <div class="row">
                  <!-- <div class="col-md-6 mt-3">
                    <label class="labeltxt">{{'District' | translate}}</label>
                    <select class="bootstrap-select" formControlName="district">
                      <option value="1" selected>Premier</option>
                      <option value="1">Deuxième </option>
                    </select>
                    <div *ngIf="isSubmitted && g.district.errors" class="invalid-feedback">
                      <div *ngIf="g.district.errors?.required">{{'District'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.district.errors?.pattern">{{'District'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div> -->
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Region'|translate}}</label>
                    <input class="text-capitalize" type="text" formControlName="business_region_name" maxlength="40">
                    <!--  <select class="bootstrap-select" formControlName="region" (change)="changeRegion($event.target.value, 1)">
                      <option selected disabled="true" [ngValue]="null">{{'Please Choose'|translate}}</option>
                      <option *ngFor="let region of regionList" value="{{region.id}}">{{region.name}}</option>
                    </select>-->
                    <div *ngIf="isSubmitted && g.business_region_name.errors" class="invalid-feedback">
                      <div *ngIf="g.business_region_name.errors?.required">{{'Region'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.business_region_name.errors?.pattern">{{'Region'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'City'|translate}}</label>
                    <input class="text-capitalize" type="text" formControlName="business_city_name" maxlength="40">
                    <!-- <select class="bootstrap-select" formControlName="city" (change)="changeCity($event.target.value)">
                      <option selected disabled="true" [ngValue]="null">{{'Please Choose'|translate}}</option>
                      <option *ngFor="let city of cityList" value="{{city.id}}">{{city.name}}</option>
                    </select>-->
                    <div *ngIf="isSubmitted && g.business_city_name.errors" class="invalid-feedback" maxlength="40">
                      <div *ngIf="g.business_city_name.errors?.required">{{'City'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.business_city_name.errors?.pattern">{{'City'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'District'|translate}}</label>
                    <input class="text-capitalize" type="text" formControlName="business_district_name" maxlength="40">
                    <!--   <select class="bootstrap-select" formControlName="district">
                      <option selected disabled="true" [ngValue]="null">{{'Please Choose'|translate}}</option>
                      <option *ngFor="let district of districtList" value="{{district.id}}">{{district.name}}</option>
                    </select>-->
                    <div *ngIf="isSubmitted && g.business_district_name.errors" class="invalid-feedback">
                      <div *ngIf="g.business_district_name.errors?.required">{{'District'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.business_district_name.errors?.pattern">{{'District'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Neighbourhood'|translate}}</label>
                    <input class="text-capitalize" type="text" formControlName="business_neighborhood_name" maxlength="40">
                    <!--   <select class="bootstrap-select" formControlName="neighborhood">
                      <option selected disabled="true" [ngValue]="null">{{'Please Choose'|translate}}</option>
                      <option *ngFor="let neighborhood of neighborhoodlist" value="{{neighborhood.id}}">{{neighborhood.name}}</option>
                    </select>-->
                    <div *ngIf="isSubmitted && g.business_neighborhood_name.errors" class="invalid-feedback">
                      <div *ngIf="g.business_neighborhood_name.errors?.required">{{'Neighbourhood'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.business_neighborhood_name.errors?.pattern">{{'Neighbourhood'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <!-- below section is under Business Location -->
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Street'|translate}}</label>
                    <input type="text" formControlName="street" maxlength="40">
                    <div *ngIf="isSubmitted && g.street.errors" class="invalid-feedback">
                      <div *ngIf="g.street.errors?.required">{{'Street'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.street.errors?.pattern">{{'Street'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Place called'|translate}}</label>
                    <input type="text" formControlName="place" maxlength="40">
                    <div *ngIf="isSubmitted && g.place.errors" class="invalid-feedback">
                      <div *ngIf="g.place.errors?.required">{{'Place called'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.place.errors?.pattern">{{'Place called'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Post box'|translate}}</label>
                    <input type="text" value="" formControlName="business_post_box" maxlength="40">
                    <div *ngIf="isSubmitted && g.business_post_box.errors" class="invalid-feedback">
                      <div *ngIf="g.business_post_box.errors?.required">{{'Post box'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.business_post_box.errors?.pattern">{{'Post box'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Locality (Village)'|translate}}</label>
                    <input type="text" formControlName="locality" maxlength="40">
                    <div *ngIf="isSubmitted && g.locality.errors" class="invalid-feedback">
                      <div *ngIf="g.locality.errors?.required">{{'Locality'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.locality.errors?.pattern">{{'Locality'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <!--Business Location ends -->
                  <div class="col-12 mt-3">
                    <div class="maparea">
                      <input ngx-google-places-autocomplete #placesRef="ngx-places" formControlName="map_address" placeholder="{{'Search your location' | translate }}" (onAddressChange)="handleAddressChange($event,'search')" class="mt-4" />
                      <img src="/assets/images/location.png" class="img-fluid" />
                    </div>
                    <div *ngIf="isSubmitted && g.map_address.errors" class="invalid-feedback">
                      <div *ngIf="g.map_address.errors?.required">{{'Location'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.map_address.errors?.pattern">{{'Location'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                    <div #map class="gmaps" style="width: 100%; height: 400px;"></div>
                    <p class="maptext">{{ 'maptext' | translate }}</p>
                    <p class="maptext red">{{ 'maptextinred' | translate }}</p>
                  </div>
                </div>
              </div>
              <div class="container mt-5">
                <h6 class="">{{'Contact Details' | translate}}</h6>
              </div>
              <div class="line"></div>
              <div class="container">
                <div class="row">
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Téléphone'|translate}}</label>
                    <input type="text" formControlName="telephone">
                    <div *ngIf="isSubmitted && g.telephone.errors" class="invalid-feedback">
                      <div *ngIf="g.telephone.errors?.required">{{'Téléphone'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.telephone.errors?.pattern">{{'Téléphone'|translate}} {{'should be valid'|translate}}</div>
                      <!-- <div *ngIf="g.telephone.hasError('minlength')">{{ 'Mobile' | translate }} {{ 'must Contain 8 Numbers' | translate }}</div> -->
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Email Address'|translate}}</label>
                    <input class="text-lowercase" type="text" value="" formControlName="email" maxlength="40">
                    <div *ngIf="isSubmitted && g.email.errors" class="invalid-feedback">
                      <div *ngIf="g.email.errors?.required">{{'Email Address'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.email.errors?.pattern">{{'Email Address'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <!--below section is under Contact Details -->
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Website'|translate}}</label>
                    <input type="text" formControlName="website" placeholder="www.example.com" maxlength="40">
                    <div *ngIf="isSubmitted && g.website.errors" class="invalid-feedback">
                      <!-- <div *ngIf="g.website.errors?.required">{{'Website'|translate}} {{'is required'|translate}}</div> -->
                      <div *ngIf="g.website.errors?.pattern">{{'Website'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Fax'|translate}}</label>
                    <input type="text" value="" formControlName="fax" maxlength="40">
                    <div *ngIf="isSubmitted && g.fax.errors" class="invalid-feedback">
                      <!-- <div *ngIf="g.fax.errors?.required">{{'Fax'|translate}} {{'is required'|translate}}</div> -->
                      <div *ngIf="g.fax.errors?.pattern">{{'Fax'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <!-- Contact Details ends -->
                </div>
              </div>
              <div class="container mt-5">
                <h6 class="">{{'Details of Business Owner' | translate}}</h6>
              </div>
              <div class="line"></div>
              <div class="container">
                <div class="row">
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'First name2'|translate}}</label>
                    <input type="text" value="" formControlName="first_name" maxlength="40">
                    <div *ngIf="isSubmitted && g.first_name.errors" class="invalid-feedback">
                      <div *ngIf="g.first_name.errors?.required">{{'First name2'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.first_name.errors?.pattern">{{'First name2'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Last name2'|translate}}</label>
                    <input type="text" value="" formControlName="last_name" maxlength="40">
                    <div *ngIf="isSubmitted && g.last_name.errors" class="invalid-feedback">
                      <div *ngIf="g.last_name.errors?.required">{{'Last name2'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.last_name.errors?.pattern">{{'Last name2'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <!--         <div class="col-md-6 mt-3">
                    <label for="">{{'Birthdate'| translate}}</label>
                    <input type="text" formControlName="birthdate">
                    <div *ngIf="isSubmitted && g.birthdate.errors" class="invalid-feedback">
                      <div *ngIf="g.birthdate.errors?.required">{{'Birthdate'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.birthdate.errors?.pattern">{{'Birthdate'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div> -->
                  <div class="col-md-6 mt-3" [owlDateTimeTrigger]="isDisable ? null : dt43" disabled="isDisable">
                    <label class="labeltxt ">{{'Date of Birth' | translate}}</label>
                    <div class="date-field">
                      <input [max]="minDateOfBirth" [min]="" [owlDateTime]="dt43" name="birth_date" formControlName="birth_date">
                      <div class="input-group-prepend" [ngClass]="{'d-none': isDisable}">
                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                    </div>
                    <div *ngIf="isSubmitted && g.birth_date.errors" class="invalid-feedback">
                      <div *ngIf="g.birth_date.errors?.required">{{'Date of birth'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.birth_date.errors?.pattern">{{ 'Minimum age requirement is 16 years' | translate }}</div>
                    </div>
                    <owl-date-time [disabled]="true" [pickerType]="'calendar'" #dt43></owl-date-time>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Birthplace'| translate}}</label>
                    <input type="text" formControlName="birth_place" maxlength="40">
                    <div *ngIf="isSubmitted && g.birth_place.errors" class="invalid-feedback">
                      <div *ngIf="g.birth_place.errors?.required">{{'Birthplace'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.birth_place.errors?.pattern">{{'Birthplace'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'ID proof'|translate}}</label>
                    <!-- <input type="text" formControlName="idproof"> -->
                    <select class="bootstrap-select" formControlName="id_proof" maxlength="40">
                      <option value="null" disabled selected>{{'Please Select one' | translate}}</option>
                      <option *ngFor="let idProof of idproofList" value="{{idProof.type}}">{{idProof.name}}</option>
                    </select>
                    <div *ngIf="isSubmitted && g.id_proof.errors" class="invalid-feedback">
                      <div *ngIf="g.id_proof.errors?.required">{{'ID proof'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.id_proof.errors?.pattern">{{'ID proof'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'ID proof number'|translate}}</label>
                    <input type="text" formControlName="id_number" maxlength="40">
                    <div *ngIf="isSubmitted && g.id_number.errors" class="invalid-feedback">
                      <div *ngIf="g.id_number.errors?.required">{{'ID proof number'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.id_number.errors?.pattern">{{'ID proof number'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Phone number'|translate}}</label>
                    <input type="text" formControlName="phone_no" maxlength="40">
                    <div *ngIf="isSubmitted && g.phone_no.errors" class="invalid-feedback">
                      <div *ngIf="g.phone_no.errors?.required">{{'Phone number'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.phone_no.errors?.pattern">{{'Phone number'|translate}} {{'should be valid'|translate}}</div>
                      <!--   <div *ngIf="g.phoneno.hasError('minlength')">{{ 'Mobile' | translate }} {{ 'must Contain 8 Numbers' | translate }}</div>
                      <div *ngIf="g.phoneno.hasError('maxlength')">{{ 'Mobile' | translate }} {{ 'must Contain only 8 Numbers' | translate }}</div> -->
                    </div>
                  </div>
                  <!--     <div class="col-md-6 mt-3">
                    <label for="">{{'Country'|translate}}</label>
                    <input type="text" formControlName="country">
                    <div *ngIf="isSubmitted && g.country.errors" class="invalid-feedback">
                      <div *ngIf="g.country.errors?.required">{{'Country'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.country.errors?.pattern">{{'Country'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
 -->
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Nationality'|translate}}</label>
                    <select class="bootstrap-select" formControlName="owner_nationality_id" maxlength="40">
                      <option *ngFor="let nationality of countryList" value="{{nationality.id}}">{{nationality.nationality}}</option>
                    </select>
                    <div *ngIf="isSubmitted && g.owner_nationality_id.errors" class="invalid-feedback">
                      <div *ngIf="g.owner_nationality_id.errors?.required">{{'Nationality'|translate}} {{'is required'|translate}}</div>
                      <!-- <div *ngIf="g.owner_nationality_id.errors?.pattern">{{'Nationality'|translate}} {{'should be valid'|translate}}</div> -->
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'City'|translate}}</label>
                    <input type="text" formControlName="owner_city_name" maxlength="40">
                    <!--   <select class="bootstrap-select" formControlName="owner_city">
                      <option value="null" disabled selected>{{'Please Select one' | translate}}</option>
                      <option *ngFor="let city of ownerCityList" value="{{city.id}}">{{city.name}}</option>
                    </select>-->
                    <div *ngIf="isSubmitted && g.owner_city_name.errors" class="invalid-feedback">
                      <div *ngIf="g.owner_city_name.errors?.required">{{'City'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.owner_city_name.errors?.pattern">{{'City'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Country'|translate}}</label>
                    <select class="bootstrap-select" formControlName="owner_country_id" maxlength="40">
                      <option *ngFor="let country of countryList" value="{{country.id}}">{{country.name}}</option>
                    </select>
                    <!--  <div *ngIf="isSubmitted && g.country.errors" class="invalid-feedback">
                      <div *ngIf="g.owner_country.errors?.required">{{'Country'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.owner_country.errors?.pattern">{{'Country'|translate}} {{'should be valid'|translate}}</div>
                    </div> -->
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Region'|translate}}</label>
                    <input type="text" formControlName="owner_region_name" maxlength="40">
                    <!-- <select class="bootstrap-select" formControlName="owner_region_name">
                      <option selected disabled="true" [ngValue]="null">{{'Please Choose'|translate}}</option>
                      <option *ngFor="let region of regionList" value="{{region.id}}">{{region.name}}</option>
                    </select>-->
                    <div *ngIf="isSubmitted && g.owner_region_name.errors" class="invalid-feedback">
                      <!-- <div *ngIf="g.owner_region_name.errors?.required">{{'Region'|translate}} {{'is required'|translate}}</div> -->
                      <div *ngIf="g.owner_region_name.errors?.pattern">{{'Region'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Neighbourhood'|translate}}</label>
                    <input type="text" formControlName="owner_neighbourhood_name" maxlength="40">
                    <!-- <select class="bootstrap-select" formControlName="owner_neighbourhood_name">
                      <option selected disabled="true" [ngValue]="null">{{'Please Choose'|translate}}</option>
                      <option *ngFor="let neighborhood of neighborhoodlist" value="{{neighborhood.id}}">{{neighborhood.name}}</option>
                    </select>-->
                    <div *ngIf="isSubmitted && g.owner_neighbourhood_name.errors" class="invalid-feedback">
                      <!-- <div *ngIf="g.owner_neighbourhood_name.errors?.required">{{'Neighbourhood'|translate}} {{'is required'|translate}}</div> -->
                      <div *ngIf="g.owner_neighbourhood_name.errors?.pattern">{{'Neighbourhood'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'District'|translate}}</label>
                    <input type="text" formControlName="owner_district_name" maxlength="40">
                    <div *ngIf="isSubmitted && g.owner_district_name.errors" class="invalid-feedback">
                      <!--<div *ngIf="g.owner_district_name.errors?.required">{{'District'|translate}} {{'is required'|translate}}</div> -->
                      <div *ngIf="g.owner_district_name.errors?.pattern">{{'District'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Street'|translate}}</label>
                    <input type="text" formControlName="owner_street_name" maxlength="40">
                    <div *ngIf="isSubmitted && g.owner_street_name.errors" class="invalid-feedback">
                      <!--<div *ngIf="g.owner_street_name.errors?.required">{{'Street'|translate}} {{'is required'|translate}}</div> -->
                      <div *ngIf="g.owner_street_name.errors?.pattern">{{'Street'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'N° Porte'|translate}}</label>
                    <input type="text" formControlName="owner_door_no" maxlength="40">
                    <div *ngIf="isSubmitted && g.owner_door_no.errors" class="invalid-feedback">
                      <!--<div *ngIf="g.owner_door_no.errors?.required">{{'N° Porte'|translate}} {{'is required'|translate}}</div>-->
                      <div *ngIf="g.owner_door_no.errors?.pattern">{{'N° Porte'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Place called'|translate}}</label>
                    <input type="text" formControlName="owner_place" maxlength="40">
                    <div *ngIf="isSubmitted && g.owner_place.errors" class="invalid-feedback">
                      <!--<div *ngIf="g.owner_place.errors?.required">{{'Place called'|translate}} {{'is required'|translate}}</div>-->
                      <div *ngIf="g.owner_place.errors?.pattern">{{'Place called'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Locality (Village)'|translate}}</label>
                    <input type="text" formControlName="owner_locality" maxlength="40">
                    <div *ngIf="isSubmitted && g.owner_locality.errors" class="invalid-feedback">
                      <!--<div *ngIf="g.owner_locality.errors?.required">{{'Locality (Village)'|translate}} {{'is required'|translate}}</div>-->
                      <div *ngIf="g.owner_locality.errors?.pattern">{{'Locality (Village)'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Post box'|translate}}</label>
                    <input type="text" formControlName="owner_post_box" maxlength="40">
                    <div *ngIf="isSubmitted && g.owner_post_box.errors" class="invalid-feedback">
                      <!-- <div *ngIf="g.owner_post_box.errors?.required">{{'Post box'|translate}} {{'is required'|translate}}</div> -->
                      <div *ngIf="g.owner_post_box.errors?.pattern">{{'Post box'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div>
                  <!-- <div class="col-md-6 mt-3">
                    <label for="">{{'CNSS ID2'|translate}}</label>
                    <input   type="text" formControlName="cnss_id">
                    <div *ngIf="isSubmitted && g.cnss_id.errors" class="invalid-feedback">
                      <div *ngIf="g.cnss_id.errors?.required">{{'CNSS ID2'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.cnss_id.errors?.pattern">{{'CNSS ID2'|translate}} {{'should be valid'|translate}}</div>
                    </div>
                  </div> -->
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Personal email'|translate}}</label>
                    <input type="text" class="text-lowercase" formControlName="owner_email" maxlength="40">
                    <div *ngIf="isSubmitted && g.owner_email.errors" class="invalid-feedback">
                      <div *ngIf="g.owner_email.errors?.required">{{'Personal email'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.owner_email.errors?.pattern">{{'Personal email'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- NEW FIELDS  !-->
              <div class="container mt-5">
                <h6 class="">{{'Additional Details' | translate}}</h6>
              </div>
              <div class="line"></div>
              <div class="container">
                <div class="row">
                  <div class="col-md-12 mt-3">
                    <label class="" for="">{{'Activity'|translate}}</label>
                    <textarea rows="6" cols="200" type="text" formControlName="activity" maxlength="40"></textarea>
                    <div *ngIf="isSubmitted && g.activity.errors" class="invalid-feedback">
                      <div *ngIf="g.activity.errors?.required">{{'Activity'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.activity.errors?.pattern">{{'Activity'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label class="" for="">{{'Address'|translate}}</label>
                    <input type="text" formControlName="address" maxlength="40">
                    <div *ngIf="isSubmitted && g.address.errors" class="invalid-feedback">
                      <div *ngIf="g.address.errors?.required">{{'Address'|translate}} {{'is required'|translate}}</div>
                      <div *ngIf="g.address.errors?.pattern">{{'Address'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Municipality'|translate}}</label>
                    <input type="text" formControlName="municipality" maxlength="40">
                    <div *ngIf="isSubmitted && g.municipality.errors" class="invalid-feedback">
                      <div *ngIf="g.municipality.errors?.pattern">{{'Municipality'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Township'|translate}}</label>
                    <input type="text" formControlName="township" maxlength="40">
                    <div *ngIf="isSubmitted && g.township.errors" class="invalid-feedback">
                      <div *ngIf="g.township.errors?.pattern">{{'Township'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Local community'|translate}}</label>
                    <input type="text" formControlName="local_community" maxlength="40">
                    <div *ngIf="isSubmitted && g.local_community.errors" class="invalid-feedback">
                      <div *ngIf="g.local_community.errors?.pattern">{{'Local community'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <!--       <div class="col-md-6 mt-3">
                    <label for="">{{'N° Porte'|translate}}</label>
                    <input type="text" formControlName="door_no">
                  </div> -->
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Administration name'|translate}}</label>
                    <input type="text" formControlName="administration_name" maxlength="40">
                    <div *ngIf="isSubmitted && g.administration_name.errors" class="invalid-feedback">
                      <div *ngIf="g.administration_name.errors?.pattern">{{'Administration name'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Department'|translate}}</label>
                    <input type="text" formControlName="department" maxlength="40">
                    <div *ngIf="isSubmitted && g.department.errors" class="invalid-feedback">
                      <div *ngIf="g.department.errors?.pattern">{{'Department'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3" [owlDateTimeTrigger]="dt56">
                    <label for="">{{'Takeover date'|translate}}</label>
                    <div class="date-field">
                      <input [owlDateTime]="dt56" name="takeover_date" formControlName="takeover_date">
                      <div class="input-group-prepend">
                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                      </div>
                    </div>
                    <owl-date-time [pickerType]="'calendar'" #dt56></owl-date-time>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Former business manager'|translate}}</label>
                    <input type="text" formControlName="business_manager" maxlength="40">
                    <div *ngIf="isSubmitted && g.business_manager.errors" class="invalid-feedback">
                      <div *ngIf="g.business_manager.errors?.pattern">{{'Former business manager'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Employer Plan'|translate}}</label>
                    <input type="text" formControlName="employer_plan" maxlength="40">
                    <div *ngIf="isSubmitted && g.employer_plan.errors" class="invalid-feedback">
                      <div *ngIf="g.employer_plan.errors?.pattern">{{'Employer Plan'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Tax'|translate}}</label>
                    <input type="text" formControlName="tax" maxlength="40">
                    <div *ngIf="isSubmitted && g.tax.errors" class="invalid-feedback">
                      <div *ngIf="g.tax.errors?.pattern">{{'Tax'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'SEEG subscription number'|translate}}</label>
                    <input type="text" formControlName="seeg_subscription_no" maxlength="40">
                    <div *ngIf="isSubmitted && g.seeg_subscription_no.errors" class="invalid-feedback">
                      <div *ngIf="g.seeg_subscription_no.errors?.pattern">{{'SEEG subscription number'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Maiden name'|translate}}</label>
                    <input type="text" formControlName="maiden_name" maxlength="40">
                    <div *ngIf="isSubmitted && g.maiden_name.errors" class="invalid-feedback">
                      <div *ngIf="g.maiden_name.errors?.pattern">{{'Maiden name'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Position'|translate}}</label>
                    <input type="text" formControlName="position" maxlength="40">
                    <div *ngIf="isSubmitted && g.position.errors" class="invalid-feedback">
                      <div *ngIf="g.position.errors?.pattern">{{'Position'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Manager'|translate}}</label>
                    <div class="radio-container">
                      <input type="radio" formControlName="manager" [value]="1"> <span>{{'Yes'|translate}}</span>
                      <input type="radio" formControlName="manager" [value]="0"> <span>{{'No'|translate}}</span>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Employer fund'|translate}}</label>
                    <input type="text" formControlName="employer_fund" maxlength="40">
                    <div *ngIf="isSubmitted && g.employer_fund.errors" class="invalid-feedback">
                      <div *ngIf="g.employer_fund.errors?.pattern">{{'Employer fund'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Employer ID'|translate}}</label>
                    <input type="text" formControlName="employer_code" maxlength="40">
                    <div *ngIf="isSubmitted && g.employer_code.errors" class="invalid-feedback">
                      <div *ngIf="g.employer_code.errors?.pattern">{{'Employer ID'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Insurrance Number'|translate}}</label>
                    <input type="text" formControlName="insurrance_no" maxlength="15" (input)="formatCNAMGS($event, '2')">
                    <div *ngIf="isSubmitted && g.insurrance_no.errors" class="invalid-feedback">
                      <div *ngIf="g.insurrance_no.errors?.pattern">{{'Insurrance Number'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-4" *ngIf="fc_certificate_url">
                    <!-- <label for="fc_certificate" class="labeltxt">{{'Incorporation certificate (FC)' | translate}}</label> -->
                    <a id="fc_certificate_name" [attr.href]="fc_certificate_url ? fc_certificate_url : null" class="viewFile text-center" target="_blank">
                      <label for="fc_certificate" class="file-upload-card labeltxt ">
                        <div class="custom-container">
                          <!-- <img src="assets/images/upload_icon.png"> -->
                          <!-- <p class="text-center">{{'Upload image or drop a file' | translate}}</p> -->
                          <i class="fa fa-download" aria-hidden="true"></i>
                          <label for="fc_certificate" class="labeltxt ">{{'Incorporation certificate (FC)' | translate}}</label>
                        </div>
                      </label>
                    </a>
                    <!--  <input class="d-none" id="fc_certificate" type="file" name="fc_certificate" (change)="upload('fc_certificate', 'fc_certificate_name', $event, 'business_fc_certificate')" data-target="business_fc_certificate">
                  
                    <div *ngIf="isSubmitted && g.business_fc_certificate.errors" class="invalid-feedback">
                      <div *ngIf="g.business_fc_certificate.errors?.required">{{'Upload Incorporation certificate (FC)'|translate}} {{'is required'|translate}}</div>
                    </div> -->
                  </div>
                  <div class="col-md-6 mt-4" *ngIf="kbis_url">
                    <!-- <label for="fc_certificate" class="labeltxt">{{'Incorporation certificate (FC)' | translate}}</label> -->
                    <a id="fc_certificate_name" [attr.href]="kbis_url ? kbis_url : null" class="viewFile text-center" target="_blank">
                      <label for="kbis_certificate" class="file-upload-card labeltxt ">
                        <div class="custom-container">
                          <!-- <img src="assets/images/upload_icon.png"> -->
                          <!-- <p class="text-center">{{'Upload image or drop a file' | translate}}</p> -->
                          <i class="fa fa-download" aria-hidden="true"></i>
                          <label for="kbis_certificate" class="labeltxt ">{{'K-BIS Certificate' | translate}}</label>
                        </div>
                      </label>
                    </a>
                    <!--  <input class="d-none" id="fc_certificate" type="file" name="fc_certificate" (change)="upload('fc_certificate', 'fc_certificate_name', $event, 'business_fc_certificate')" data-target="business_fc_certificate">
                  
                    <div *ngIf="isSubmitted && g.business_fc_certificate.errors" class="invalid-feedback">
                      <div *ngIf="g.business_fc_certificate.errors?.required">{{'Upload Incorporation certificate (FC)'|translate}} {{'is required'|translate}}</div>
                    </div> -->
                  </div>
                  <div *ngIf="statuts_url" class="col-md-6 mt-3">
                    <!-- <label for="statuts" class="labeltxt">{{'Statuts' | translate}}</label> -->
                    <a id="statuts_name" [attr.href]="statuts_url ? statuts_url : null" class="viewFile text-center" target="_blank">
                      <label for="statuts" class="file-upload-card labeltxt">
                        <div class="custom-container">
                          <!-- <img src="assets/images/upload_icon.png"> -->
                          <!-- <p class="text-center">{{'Upload image or drop a file' | translate}}</p> -->
                          <i class="fa fa-download" aria-hidden="true"></i>
                          <label for="statuts" class="labeltxt">{{'Statuts' | translate}}</label>
                        </div>
                      </label>
                    </a>
                    <!-- <input class="d-none" id="statuts" type="file" name="statuts" (change)="upload('statuts', 'statuts_name', $event, 'statuts_business')" data-target="statuts_business"> -->
                    <!--  <div *ngIf="isSubmitted && g.statuts_business.errors" class="invalid-feedback">
                      <div *ngIf="g.statuts_business.errors?.required">{{'Upload Statuts'|translate}} {{'is required'|translate}}</div>
                    </div> -->
                  </div>
                  <div *ngIf="technical_license_url" class="col-md-6 mt-3">
                    <!-- <label for="technical_license" class="labeltxt">{{'Technical license' | translate}}</label> -->
                    <a id="technical_license_name" [attr.href]="technical_license_url ? technical_license_url : null" class="viewFile text-center" target="_blank">
                      <label for="technical_license" class="file-upload-card labeltxt">
                        <div class="custom-container">
                          <!-- <img src="assets/images/upload_icon.png"> -->
                          <!-- <p class="text-center">{{'Upload image or drop a file' | translate}}</p> -->
                          <i class="fa fa-download" aria-hidden="true"></i>
                          <label for="technical_license" class="labeltxt">{{'Technical license' | translate}}</label>
                        </div>
                      </label>
                    </a>
                    <!--   <input class="d-none" id="technical_license" type="file" name="technical_license" (change)="upload('technical_license', 'technical_license_name', $event, 'business_technical_license')" data-target="business_technical_license">
                    
                    <div *ngIf="isSubmitted && g.business_technical_license.errors" class="invalid-feedback">
                      <div *ngIf="g.business_technical_license.errors?.required">{{'Upload Technical license'|translate}} {{'is required'|translate}}</div>
                    </div> -->
                  </div>
                </div>
                <hr>
                <div class="row">
                  <div class="col-md-6 mt-3">
                    <div class="signature-parent">
                      <label class="" for="">{{'Signature'|translate}}</label>
                      <div class="signature-container">
                        <img *ngIf="companyDetails" src="{{companyDetails.signature}}">
                        <input type="text d-none" formControlName="signature">
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <div class="stamp-parent">
                      <label class="" for="company_stamp">{{'Stamp of Company'|translate}}<span *ngIf="company_stamp_url" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
                      <label for="company_stamp" class="file-upload-card labeltxt">
                        <div class="custom-container">
                          <!-- <img src="assets/images/upload_icon.png"> -->
                          <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                          <i class="fa fa-upload" aria-hidden="true"></i>
                        </div>
                      </label>
                      <input type="file" id="company_stamp" (change)="upload($event, 'company_stamp')" data-target="company_stamp">
                      <small *ngIf="!company_stamp_url" class="text-sm">Note : {{'Please upload a stamp image'|translate}} (150px x 150px)</small>
                      <a *ngIf="company_stamp_url" class="viewFile text-center" href="{{company_stamp_url}}" target="_blank">{{'Click to view File'|translate}}</a>
                      <div *ngIf="isSubmitted && g.company_stamp.errors" class="invalid-feedback">
                        <div *ngIf="g.company_stamp.errors?.required">{{'Stamp of Company'|translate}} {{'is required'|translate}}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6 mt-3">
                    <div class="stamp-parent">
                      <label class="" for="company_stamp">{{'NIF Certificate'|translate}}<span *ngIf="nif_certificate_url" class="ml-1"><i class="fa fa-check-circle"></i></span></label>
                      <label for="nif_certificate" class="file-upload-card labeltxt">
                        <div class="custom-container">
                          <p class="text-center">{{'Upload image or drop a file' | translate}}</p>
                          <i class="fa fa-upload" aria-hidden="true"></i>
                        </div>
                      </label>
                      <input type="file" id="nif_certificate" (change)="upload($event, 'nif_certificate')" data-target="nif_certificate">
                      <!-- <small>Note : {{'Please upload a stamp image'|translate}} (150px x 150px)</small> -->
                      <a *ngIf="nif_certificate_url" class="viewFile text-center" href="{{nif_certificate_url}}" target="_blank">{{'Click to view File'|translate}}</a>
                      <div *ngIf="isSubmitted && g.nif_certificate.errors" class="invalid-feedback">
                        <div *ngIf="g.nif_certificate.errors?.required">{{'NIF Certificate'|translate}} {{'is required'|translate}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="bankdata && bankdata.length !=0" id="bank-money-Section">
                <div class="container mt-5">
                  <h6 class="">{{'Bank Details' | translate}}</h6>
                </div>
                <div class="line"></div>
                <div class="container" id="bank_section">
                  <div class="row">
                    <div class="col-md-12 mt-3">
                      <div class="bank-card" *ngFor="let bank of bankdata; let i = index">
                        <div class="row align-items-center">
                          <div class="col-md-1">
                            <div class="tableFooter">
                              <div class="form-check">
                                <input class="form-check-input" type="checkbox" [value]="bank.bank_id" id="flexCheckDefault" (change)="onChange(bank, $event.target.checked)" checked>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <label for="bank{{ bank.bank_id }}">
                              <img src="{{ bank.bank_logo }}">
                            </label>
                            <div class="card-child">
                              <label class="" for="">{{'Account no'|translate}}&nbsp;:&nbsp;</label>
                              <h5> {{bank.ac_number}}</h5>
                            </div>
                            <div class="card-child">
                              <label for="">{{'Company Name'|translate}}&nbsp;:&nbsp;</label>
                              <h5> {{bank.account_name}}</h5>
                            </div>
                            <div class="card-child">
                              <label for="">{{'Bank name'|translate}}&nbsp;:&nbsp;</label>
                              <h5>{{bank.bank_name}}</h5>
                            </div>
                            <div *ngIf="bank?.rib_key" class="card-child">
                              <label class="" for="">{{'RIB key '|translate}}&nbsp;:&nbsp;</label>
                              <h5> {{bank.rib_key}}</h5>
                            </div>
                          </div>
                          <div class="col-md-5">
                            <div class="card-child">
                              <label class="" for="">{{'Bank number'|translate}}&nbsp;:&nbsp;</label>
                              <h5> {{bank.bank_number}}</h5>
                            </div>
                            <div class="card-child mb-3">
                              <label for="">{{'Bank counter'|translate}}&nbsp;:&nbsp;</label>
                              <!-- <input   type="text" formControlName="i"> -->
                              <h5> {{bank.counter_code}}</h5>
                            </div>
                            <div *ngIf="bank.bank_type == 1" class="custom-container">
                              <!--  <a [attr.href]="bank_ac_statement_url ? bank_ac_statement_url : null" target="_blank">
                                </a> -->
                              <label for="bank_ac_statement{{i}}" class="file-upload-card labeltxt">
                                <div class="custom-container">
                                  <i class="fa fa-upload" aria-hidden="true"></i>
                                  <label for="bank_ac_statement{{i}}" class="labeltxt">{{'Bank account statement' | translate}}</label>
                                </div>
                              </label>
                              <input class="d-none" id="bank_ac_statement{{i}}" type="file" name="bank_ac_statement{{i}}" (change)="upload($event, bank.bank_id)" data-target="bank_slip">
                              <a id="bank_ac_statement_name" href="{{bank_ac_statement_url}}" class="viewFile text-center" target="_blank"></a>
                              <div *ngIf="isSubmitted && !bank_ac_statement_url" class="invalid-feedback">
                                <div *ngIf="!bank_ac_statement_url">{{'Upload Incorporation certificate (FC)'|translate}} {{'is required'|translate}}</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- <div *ngIf="isSubmitted && g.selected_bank_id.errors" class="invalid-feedback">
                        <div *ngIf="g.selected_bank_id.errors?.required">{{'Bank Details'|translate}} {{'is required'|translate}}</div>
                      </div> -->
                    </div>
                  </div>
                  <div class="row">
                    <!--             <div class="col-md-6 col-12 mt-3">
              <label for="">{{'Guardianship (If Administration/Collectivity)'|translate}}</label>
              <input type="text" value="" formControlName="guardianship">
              <div *ngIf="isSubmitted && f.guardianship.errors" class="invalid-feedback">
                <div *ngIf="f.guardianship.errors?.required">{{'Guardianship (If Administration/Collectivity)'|translate}} {{'is required'|translate}}</div>
                <div *ngIf="f.guardianship.errors?.pattern">{{'Guardianship (If Administration/Collectivity)'|translate}} {{'should be valid'|translate}}</div>
              </div>
            </div> -->
                    <!--             <div class="col-md-6 col-12 mt-3">
              <label for="">{{"Branch of activity"|translate}}</label>
              <input type="text" value="" formControlName="branch_of_activity">
              <div *ngIf="isSubmitted && f.branch_of_activity.errors" class="invalid-feedback">
                <div *ngIf="f.branch_of_activity.errors?.required">{{"Branch of activity"|translate}} {{'is required'|translate}}</div>
                <div *ngIf="f.branch_of_activity.errors?.pattern">{{"Branch of activity"|translate}} {{'should be valid'|translate}}</div>
              </div>
            </div> -->
                  </div>
                  <!--        <div class="row">
            <div class="col-md-6 col-12 mt-2">
              <label for="">{{'Men'|translate}}</label>
              <input type="text" value="" formControlName="workers_men">
              <div *ngIf="isSubmitted && f.workers_men.errors" class="invalid-feedback">
                <div *ngIf="f.workers_men.errors?.required">{{'Men'|translate}} {{'is required'|translate}}</div>
                <div *ngIf="f.workers_men.errors?.pattern">{{'Men'|translate}} {{'should be valid'|translate}}</div>
              </div>
            </div>
            <div class="col-md-6 col-12 mt-2">
              <label for="">{{'Women'|translate}}</label>
              <input type="text" value="" formControlName="workers_women">
              <div *ngIf="isSubmitted && f.workers_women.errors" class="invalid-feedback">
                <div *ngIf="f.workers_women.errors?.required">{{'Women'|translate}} {{'is required'|translate}}</div>
                <div *ngIf="f.workers_women.errors?.pattern">{{'Women'|translate}} {{'should be valid'|translate}}</div>
              </div>
            </div>
          </div> -->
                  <!--        <div class="container mt-5">
            <h6 class="">{{'Number of workers' | translate}}</h6>
          </div>
          <div class="row">
            <div class="col-md-6 col-12 mt-2">
              <label for="">{{'Men'|translate}}</label>
              <input type="text" value="" formControlName="men_interns">
            </div>
            <div class="col-md-6 col-12 mt-2">
              <label for="">{{'Women'|translate}}</label>
              <input type="text" value="" formControlName="women_interns">
            </div>
          </div>
 -->
                </div>
              </div>
              <div class="container">
                <div class="row">
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Guardianship'|translate}}</label>
                    <input type="text" formControlName="guardianship" maxlength="40">
                    <div *ngIf="isSubmitted && g.guardianship.errors" class="invalid-feedback">
                      <div *ngIf="g.guardianship.errors?.pattern">{{'Guardianship'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Branch of activity'|translate}}</label>
                    <input type="text" formControlName="branch_of_activity" maxlength="40">
                    <div *ngIf="isSubmitted && g.branch_of_activity.errors" class="invalid-feedback">
                      <div *ngIf="g.branch_of_activity.errors?.pattern">{{'Branch of activity'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container mt-3">
                <h6 class="">{{'Nombre de travailleurs'|translate}}</h6>
              </div>
              <div class="container">
                <div class="row">
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Men'|translate}}</label>
                    <input type="tel" formControlName="worker_men" maxlength="6">
                    <div *ngIf="isSubmitted && g.worker_men.errors" class="invalid-feedback">
                      <div *ngIf="g.worker_men.errors?.pattern">{{'Men'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6 mt-3">
                    <label for="">{{'Women'|translate}}</label>
                    <input type="tel" formControlName="worker_women" maxlength="6">
                    <div *ngIf="isSubmitted && g.worker_women.errors" class="invalid-feedback">
                      <div *ngIf="g.worker_women.errors?.pattern">{{'Women'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="container mt-3">
                <h6 class="">{{'Number of interns' | translate}}</h6>
              </div>
              <div class="container">
                <div class="row">
                  <div class="col-md-6">
                    <label for="">{{'Men'|translate}}</label>
                    <input type="tel" formControlName="interns_men_no" maxlength="6">
                    <div *ngIf="isSubmitted && g.interns_men_no.errors" class="invalid-feedback">
                      <div *ngIf="g.interns_men_no.errors?.pattern">{{'Men'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <label for="">{{'Women'|translate}}</label>
                    <input type="tel" formControlName="interns_women_no" maxlength="6">
                    <div *ngIf="isSubmitted && g.interns_women_no.errors" class="invalid-feedback">
                      <div *ngIf="g.interns_women_no.errors?.pattern">{{'Women'|translate}} {{'should be valid'|translate}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 mt-3">
                  <div class="tableFooter">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" [checked]="g.confirm_account.value" id="confirm_account" formControlName="confirm_account">
                      <label class="form-check-label" for="confirm_account">
                        {{'By clicking on' | translate}} <b>{{'Following' | translate}} </b>{{"declaration, you certify that the information declared reflects the reality of the company's social situation." | translate}}
                      </label>
                    </div>
                    <div *ngIf="isSubmitted && g.confirm_account.errors" class="invalid-feedback checkvalid">
                      <div *ngIf="g.confirm_account.errors?.required">{{'Please check the declaration to Continue'|translate}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button type="submit" id="submit_btn" class="btn btn-medium">{{'Proceed' | translate}}</button>
      </form>
    </div>
  </div>
</section>
<!-- <section class="footer-section">
  <div class="footer-top">
    <div class="footer-main">
      <div class="row">
        <div class="col-md-8 col-lg-6 col-xl-6 col-sm-12 offset-xl-1">
          <div class="txt-container">
            <a class="logo-block" href="index.html">PUPS</a>
            <p>{{'footer text' | translate}}</p>
          </div>
        </div>
        <div class="col-md-4 col-lg-4 col-xl-2 col-sm-12 offset-xl-1">
          <div class="parent-container">
            <div class="txt-container">
              <ul>
                <li *ngIf="accountDetails && !isBusiness && login != '2'"><a routerLink="/link-business">{{'Link Business' | translate}}</a></li>
                <li><a routerLink="/contact-us">{{'Contact' | translate}}</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-lg-4 col-xl-3 col-sm-12 offset-xl-1">
          <div class="txt-container">
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="footer-bottom">
    <div class="footer-main">
      <div class="parent-container">
        <div class="txt-container">
          <h6>{{'All rights reserved. 2024.' | translate}} <p class="mt-2">Version 1.1.4</p>
          </h6>
        </div>
        <a href="https://clikafrikgroup.com/" target="_blank">
          <div class="txt-container">
            <h6>{{'Powered by' | translate}}</h6><img src="assets/images/clikafrik-logo.png" alt="">
          </div>
        </a>
      </div>
    </div>
  </div>
</section> -->
<app-footer></app-footer>
<app-contact-floating></app-contact-floating>
